module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid e-main"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6e8957a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ErcoMain.vue
// module id = 663
// module chunks = 0